import { render, staticRenderFns } from "./InstanceDetail.vue?vue&type=template&id=65bbc646&scoped=true&"
import script from "./InstanceDetail.vue?vue&type=script&lang=js&"
export * from "./InstanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./InstanceDetail.vue?vue&type=style&index=0&id=65bbc646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bbc646",
  null
  
)

export default component.exports